/**
 * @desc 获取所有的buSub
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BuSbuResponseDtoRpc>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/buSub/getAllBuSubs`, {
      method: "GET",

      ...options,
    }),
  );
}
